import {Link} from "react-router-dom";
import React from "react";
import {IPublicBusinessProfileProto, space} from "../../compiled";
import IBusinessLocationProto = space.kenko.proto.IBusinessLocationProto;
import {formatUrl} from "../../util/UrlUtil";

type Props = {
  businessId: string,
  location: IBusinessLocationProto  | null | undefined,
  businessProfile: IPublicBusinessProfileProto | null | undefined,
}

export const SearchResult = (props: Props) => {

  if (!props.businessProfile || !props.location) {
    return <></>;
  }
  
  return <div className={'MapSearchResult'}>
    <div className={'MapSearchResultTopRow'}>

      <div className={'MapSearchResultImageContainer'}>
        <img className={'MapSearchResultImage'} src={
          props.location.physicalLocation?.imageUrl || props.businessProfile.imageUrl || undefined}/>
      </div>

      <div className={'MapSearchResultInfo'}>
        <div><b>{props.businessProfile.businessName}{props.location.locationName && ` - ${props.location.locationName}`}</b></div>
        <div className={'InputHelpText'}>{props.location.physicalLocation?.private ? '[Location hidden until booking]' :
          props.location.physicalLocation?.address}</div>
      </div>

    </div>

    <div className={'MapSearchResultBottomRow'}>
        
      <a href={formatUrl(props.businessProfile.websiteUrl)} target={'_blank'} className={'MapSearchResultButton'}>
        SEE WEBSITE
      </a>
      {props.businessProfile.hasBooking &&
      <Link to={`/book?r=kensu&b=${props.businessId}`} className={'MapSearchResultButton'}>
        BOOK
      </Link>}
    </div>

  </div>;
}